import { CalendarDate } from '@internationalized/date';
import {
  SalesOrderCreateInput,
  SalesOrderType,
  SalesOrderStatus,
  SalesOrderLineItemInput,
  FreightTerm,
  PaymentTerm,
  AddressInput,
  WeightDisplayUnit,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const salesOrderCreateAtom = createMutationAtomFactory(
  'trade.salesOrderCreate',
  (params: {
    documentNumber?: string;
    type: SalesOrderType;
    status: SalesOrderStatus;
    startDate?: CalendarDate | null;
    endDate?: CalendarDate | null;
    accountId: string;
    counterpartyReferenceNumber?: string | null;
    contactId?: string | null;
    facilityId: string;
    accountRepresentativeId?: string | null;
    shippingAddress: AddressInput;
    billingAddress: AddressInput;
    paymentCurrency: string;
    freightTerm: FreightTerm;
    paymentTerm: PaymentTerm;
    doNotShip?: boolean;
    externalNotes?: string | null;
    internalNotes?: string | null;
    completionNotes?: string | null;
    customAttributes?: Record<string, string> | null;
    lineItems?: SalesOrderLineItemInput[];
    weightDisplayUnit?: WeightDisplayUnit | null;
    bookingIds?: string[];
  }) => {
    const input: SalesOrderCreateInput = {
      type: params.type,
      status: params.status,
      facilityId: params.facilityId,
      accountId: params.accountId,
      bookingIds: params.bookingIds,
    };

    // Only add optional fields if they have values
    if (params.documentNumber) input.documentNumber = params.documentNumber;
    if (params.startDate) input.startDate = params.startDate.toString();
    if (params.endDate) input.endDate = params.endDate.toString();
    if (params.counterpartyReferenceNumber)
      input.counterpartyReferenceNumber = params.counterpartyReferenceNumber;
    if (params.contactId) input.contactId = params.contactId;
    if (params.accountRepresentativeId)
      input.accountRepresentativeId = params.accountRepresentativeId;
    if (params.externalNotes)
      input.recyclerExternalNotes = params.externalNotes;
    if (params.internalNotes)
      input.recyclerInternalNotes = params.internalNotes;
    if (params.completionNotes) input.completionNotes = params.completionNotes;
    if (params.customAttributes)
      input.customAttributes = params.customAttributes;

    if (params.shippingAddress) {
      input.shippingAddress = params.shippingAddress;
    }
    if (params.billingAddress) {
      input.billingAddress = params.billingAddress;
    }
    if (params.paymentCurrency) {
      input.paymentCurrency = params.paymentCurrency;
    }
    if (params.freightTerm) {
      input.freightTerm = params.freightTerm;
    }
    if (params.paymentTerm) {
      input.paymentTerm = params.paymentTerm;
    }
    if (params.doNotShip !== undefined) {
      input.doNotShip = params.doNotShip;
    }
    if (params.lineItems) {
      input.lineItems = params.lineItems;
    }
    if (params.weightDisplayUnit) {
      input.weightDisplayUnit = params.weightDisplayUnit;
    }

    return {
      tradeSalesOrderCreate: {
        __args: {
          input,
        },
        id: true,
        documentNumber: true,
        status: true,
        bookings: {
          id: true,
          documentNumber: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    };
  },
);
